import axios from 'axios';

const APP_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;

const apiInstance = axios.create({
  baseURL: APP_BASE_URL,
  withCredentials: true 
});

apiInstance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      try {
        await axios.post(
          `${APP_BASE_URL}/refresh-token`,
          {},
          { withCredentials: true }
        );

        return apiInstance(error.config);
      } catch (refreshError) {}

      return Promise.reject();
    }

    // Log all other errors
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiInstance;
